/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { INurse } from 'app/shared/model/nurse.model';
import { IVitals } from 'app/shared/model/vitals.model';
import { PatientReferredTo } from 'app/shared/model/enumerations/patient-referred-to.model';

export interface IIntraOPRecovery {
  id?: string;
  levelOfRecovery?: string | null;
  coherence?: string | null;
  reflexes?: string | null;
  headLift?: string | null;
  saeaSenosoryLevel?: string | null;
  saeaMotorLevel?: string | null;
  patientReferredTo?: keyof typeof PatientReferredTo | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surgery?: IPatientProcedure;
  surgeon?: IDoctor;
  scrubNurse?: INurse;
  vitals?: IVitals | null;
}

export const defaultValue: Readonly<IIntraOPRecovery> = {
  active: false,
};
